import type { NavigationGuard } from "vue-router";

import { useProductsStore } from "@/stores";

export function fetchProductsDataGuard(): NavigationGuard {
  return async (to, from, next) => {
    const productsStore = useProductsStore();
    if (productsStore.status === "initial") {
      await productsStore.load();
    }

    return next();
  };
}
